import { inject, injectable } from 'tsyringe';
import { type IUploadFileRepository } from 'application/repositorySchemas/IUploadFileRepository';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IUploadFileClient } from 'interfaceAdapter/gatewaySchemas/IUploadFileClient';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';

@injectable()
export class UploadFileRepository implements IUploadFileRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('IUploadFileClient')
        public readonly uploadFileClient: IUploadFileClient,
    ) {}

    public upload = async (
        file: File,
        fileName: string,
        directory:
            | 'company_profile'
            | 'agent_profile'
            | 'company'
            | 'agent'
            | 'buyer_profile'
            | 'buyer'
            | 'supporter_profile'
            | 'supporter',
        fileCategory: 'agent' | 'company' | 'buyer' | 'supporter',
        width: number,
        height: number,
        urlId?: string | null,
    ): Promise<string> => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('file_name', fileName);
        formData.append('file_directory', directory);
        formData.append('file_category', fileCategory);
        formData.append('width', `${width}`);
        formData.append('height', `${height}`);
        // @ts-expect-error formDataはnullを許容しないが、APIはnullを受け付ける
        formData.append('url_id', urlId);

        const token =
            fileCategory === 'company'
                ? this.companyUserToken.get()
                : fileCategory === 'buyer'
                ? this.buyerUserToken.get()
                : fileCategory === 'supporter'
                ? this.supportUserToken.get()
                : this.agentUserToken.get();

        const { data, message } = await this.uploadFileClient.post({
            token: token ?? '',
            category: fileCategory,
            formData,
        });

        if (message) {
            throw new Error(message);
        }

        return data.url;
    };
}
